import useUpdateEffect from '@/common/hook/updateEffect/useUpdateEffect';
import { FC, useRef } from 'react';
import styles from '../index.module.less';
import { showMarker } from '@/common/utils/map';
import IconFont from '@/common/components/IconFont';
import { targetLegendIcon } from '../../../ts-config';
import { mapContainer } from '..';
import { Typography } from 'antd';
import { bigdataAction } from '@/common/utils/bigdata';

const { Paragraph } = Typography;

/**
 * @Description 经营门店（除竞品门店、知名品牌外）
 */
const StoreBrandMarker:FC<{
  mapIns: any;
  data: any[];
  contentMarkerRef: any;
  curDetail: any;
  setCurDetail: any;
  handleDetailToNull: () => void;
  onClickMarker?: any;
}> = ({
  mapIns,
  data,
  contentMarkerRef,
  curDetail,
  setCurDetail,
  handleDetailToNull,
  onClickMarker = () => {}
}) => {
  const massListRef = useRef<any>([]);
  const activeMarker = useRef<any>(null);
  const createContentMarker = (value, key, activeMarker = null) => {
    const dom = document.querySelector(`.${mapContainer}`);
    var pixel = mapIns.lngLatToContainer([value?.lng, value?.lat]);
    const { x, y } = pixel;
    const offset = [0, 0];
    let topBottom = 'top';
    let leftRight = 'center';
    if (y < 200) {
      topBottom = 'top';
    } else if ((dom?.clientHeight || 0) - y < 200) {
      topBottom = 'bottom';
      offset[1] = 0;
    }
    if (x < 200) {
      leftRight = 'left';
    } else if ((dom?.clientWidth || 0) - x < 200) {
      leftRight = 'right';
    }

    contentMarkerRef.current && mapIns.remove(contentMarkerRef.current);
    contentMarkerRef.current = new window.AMap.Marker({
      position: [value.lng, value.lat],
      anchor: `${topBottom}-${leftRight}`,
      offset,
      zIndex: 60,
      extData: {
        isStore: true, // 是否是经营门店类型，聚合后需要隐藏
        tag: key
      }
    });
    mapIns.add(contentMarkerRef.current);
    onClickMarker?.();
    showMarker(contentMarkerRef.current,
      <TargetBrand
        data={value}
        mapIns={mapIns}
        marker={contentMarkerRef.current}
        activeMarker={activeMarker}
        handleDetailToNull={handleDetailToNull}
      />);
  };
  const createMass = (data, key) => {
    const value = data.map((item) => ({
      lnglat: [+item.lng, +item.lat],
      detail: item,
      ...item,
    }));

    var mass = new window.AMap.MassMarks(value, {
      opacity: 1,
      cursor: 'pointer',
      style: {
        url: `${targetLegendIcon?.[key]}`,
        size: [24, 29],
        anchor: 'bottom-center'
      },
      zooms: [1, 20],
      zIndex: 500, // 不然会被showIndoorMap遮挡
    });
    mass.setMap(mapIns);

    mass.on('click', ({ data }) => {
      handleDetailToNull();
      setCurDetail(data);
      // 动态改变 Marker 的图标和尺寸
      activeMarker.current && mapIns.remove(activeMarker.current);
      createActiveMarker(data, key);
      // /spotevaluation/history?modelConfigId=23 查询例如跳转页未配置菜单，写死op_feat，op_menu
      bigdataAction('c0c5c3c9-3fba-43cb-89d9-9cdcdb87f650', 'spotEvaluation',
        '点位测评', '详情页-地图图标', '点击了详情页-地图图标', { op_block: '', op_event: '', });
    });
    massListRef.current.push(mass);
  };
  const createActiveMarker = (value, key) => {
    const marker = new window.AMap.Marker({
      position: [value.lng, value.lat],
      content: `<img class="storeMarkerActive" src="${targetLegendIcon?.[key]}"/>`,
      anchor: 'bottom-center',
      extData: value
    });
    activeMarker.current && mapIns.remove(activeMarker.current);
    activeMarker.current = marker;
    createContentMarker(value, key, marker);
    mapIns.add(marker);
  };
  const clearMarker = () => {
    massListRef.current?.map((mass) => {
      mass?.clear();
    });
    massListRef.current = [];
    activeMarker.current && mapIns?.remove(activeMarker.current);
  };
  useUpdateEffect(() => {
    if (!mapIns) return;
    clearMarker();
    Object.keys(data)?.map((item) => {
      createMass(data[item], item);
      // data[item].map((value) => {
      //   createMarker(value, item);
      // });
    });
  }, [mapIns, data]);

  useUpdateEffect(() => {
    activeMarker.current && mapIns.remove(activeMarker.current);
    let curValue;
    Object.keys(data).reduce((acc, key) => {
      if (acc) return acc;
      data[key].map((item) => {
        if (item.lat === curDetail?.lat && item.lng === curDetail?.lng && item?.name === curDetail?.name) {
          acc = true;
          curValue = {
            ...item,
            tag: key
          };
        };
      });
      return acc;
    }, false);

    if (curValue) {
      createContentMarker(curValue, curValue.tag);
      createActiveMarker(curValue, curValue.tag);
    }
  }, [curDetail]);


  useUpdateEffect(() => {
    const tag = contentMarkerRef.current?.getExtData()?.tag;
    if (tag && !data[tag]?.length) {
      contentMarkerRef.current && mapIns?.remove(contentMarkerRef.current);
    }
  }, [data]);

  return <div>

  </div>;
};

const TargetBrand = ({
  data,
  mapIns,
  marker,
  activeMarker,
  handleDetailToNull
}) => {

  return <div className={styles.competitorOverview}>
    <IconFont
      iconHref={'iconic_close_colour_seven'}
      className={styles.closeIcon}
      onClick={() => {
        handleDetailToNull();
        mapIns.remove(marker);
        mapIns.remove(activeMarker);
      }}
    />
    {/* <div className='fs-14 bold pr-16 ellipsis-2'>{data?.name}</div> */}
    <Paragraph
      style={{ width: 170, marginBottom: 0 }}
      ellipsis={{
        tooltip: data?.name,
        rows: 2,
      }}>
      <span className='fs-14 bold pr-16'>
        {data?.name}
      </span>
    </Paragraph>
    {
      data?.address ? <div className='c-999 fs-12 mt-6'>
        {data?.address}
      </div> : <></>
    }
  </div>;
};
export default StoreBrandMarker;
